import { formatDate, formatMoney } from "../../lib/format";

/** Iznos u srpskom zapisu (14.722.425,00 €); „—" za prazno. */
export const money = (n: number | null | undefined, cur = "EUR") => formatMoney(n, cur);

/**
 * Datum, bez obzira na to da li izvor nosi i vreme.
 *
 * `"2026-09-30"` bez dopune `T00:00:00` pada na UTC ponoć, pa se u zapadnim zonama ispiše dan
 * ranije. Ali ista dopuna nad vremenskom oznakom pravi `"2026-09-30T14:22:31ZT00:00:00"`, što
 * nije datum: `formatDate` tada vraća prazno i datum nestane sa ekrana bez ijedne greške. Tako
 * je spisak porudžbina na stranici firme pokazivao samo broj stavki, a dan nastanka nigde.
 *
 * Zato se dopunjava samo goli datum, a vremenska oznaka ide takva kakva jeste.
 */
export const fmtDate = (iso: string | null | undefined) => {
  if (iso == null || iso === "") return "—";
  return formatDate(/^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso + "T00:00:00" : iso);
};

/**
 * Koliko dana kasni račun koji je dospeo.
 *
 * Broji se od dana dospeća do danas, isto kao u grupama kašnjenja na pregledu finansija: dan
 * dospeća se ne računa u docnju, pa račun koji dospeva danas kasni nula dana. Vraća `null` kad
 * roka nema ili kad još nije prošao, da ekran nema šta da prikaže.
 */
export function docnjaDana(dueIso: string | null | undefined, danas = new Date()): number | null {
  if (!dueIso) return null;
  const rok = new Date(dueIso + "T00:00:00");
  if (Number.isNaN(rok.getTime())) return null;
  const d0 = Date.UTC(danas.getFullYear(), danas.getMonth(), danas.getDate());
  const d1 = Date.UTC(rok.getFullYear(), rok.getMonth(), rok.getDate());
  const dana = Math.floor((d0 - d1) / 86400000);
  return dana > 0 ? dana : null;
}
